import SeriesTable from './SeriesTable';

export default SeriesTable;
